
import { Prop, Component, Vue } from 'vue-property-decorator'
import Icon from '~/components/common/icon/Icon.vue'

@Component({
  name: 'ButtonFS',
  components: {
    Icon
  }
})
export default class ButtonFS extends Vue {
  @Prop({ type: String, default: 'button' }) tag!: string
  @Prop({ type: Object }) icon!: { name: string, size: string } | undefined
  @Prop({ type: String, default: 's' }) size!: 's' | 'm' | 'l'
  @Prop({ type: Boolean, default: false }) blurred: boolean

  get iconSize() {
    if (this.icon && this.icon.size) { return this.icon.size }
    return this.size === 'l' ? '16' : '14'
  }
}
